import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      display: "flex",
    },
    toolbar: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    mBottom15: {
      marginBottom: "15px",
    },
    toolbarIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 8px",
      ...theme.mixins.toolbar,
    },
    appBar: {
      position: "relative",
      backgroundColor: "var(--dmg-primary)",
      color: "white",
      boxShadow: "none",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: "none",
    },
    title: {
      flexGrow: 1,
    },
    drawerPaper: {
      position: "relative",
      whiteSpace: "nowrap",
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      overflow: "auto",
      background: "var(--dmg-blue-muted)",
      backgroundSize: "cover",
      backgroundPosition: "bottom",
      minHeight: "100vh",
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
      overflowY: "clip",
    },
    fixedHeight: {
      height: 240,
    },
    formSection: {
      background: "var(--dmg-blue-muted)",
      borderRadius: theme.spacing(0.5),
    },
    formWrapper: {
      position: "relative",
    },
    actionButtonWrapper: {
      position: "absolute",
      right: 0,
      width: "225px",
    },
    stickyActionButton: {
      position: "fixed",
      bottom: "35px",
      zIndex: 1,
      padding: "10px",
    },
    sectionWrapper: {
      boxShadow: "0 2px 1px rgb(0 0 0 / 5%), 0 0 1px rgb(0 0 0 / 45%)",
      marginBottom: "50px",
    },
    sectionHeadingTitle: {
      color: "var(--dmg-bg)",
      fontSize: "19px",
      fontWeight: 400,
    },
    sectionHeading: {
      padding: "10px 15px",
      background: "var(--dmg-primary)",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
    },
    sectionContentWrapper: {
      padding: "15px",
      border: "1px solid var(--dmg-gray-200)",
      borderTop: "none",
      borderBottom: "none",
      width: "100%",
    },
    sectionWrapperChild: {
      width: "100%",
      background: "var(--dmg-gray-100)",
      border: "1px solid var(--dmg-gray-200)",
      marginBottom: "20px",
      "&:last-child": {
        marginBottom: 0,
      },
      "& .MuiOutlinedInput-multiline, .MuiSelect-selectMenu, .MuiInputBase-input, .MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot, .MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot": {
        background: "var(--dmg-bg)",
      },
      "& .MuiInputBase-input.Mui-disabled": {
        background: "var(--dmg-gray-100)",
      },
      "& .MuiInputBase-formControl.MuiInputBase-multiline.Mui-disabled": {
        background: "var(--dmg-gray-100)",
      },
      "& hr": {
        height: "1px",
        backgroundColor: "var(--dmg-gray-200)",
        border: "none",
      },
    },
    sectionHeadingChild: {
      borderBottom: "1px solid var(--dmg-gray-200)",
      paddingBottom: "5px",
      marginBottom: "5px",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
      background: "var(--dmg-gray-100)",
    },
    sectionHeadingTitleChild: {
      color: "var(--dmg-primary)",
      fontSize: "15px",
      fontWeight: 600,
      padding: "5px 0 0px 10px",
    },
    flexCol: {
      display: "flex",
      flexDirection: "row",
    },
    bgWhite: {
      background: "var(--dmg-bg)",
    },
    devide: {
      height: "1px",
      backgroundColor: "var(--dmg-gray-200)",
      border: "none",
      marginBottom: "20px",
    },
    divider: {
      height: "1px",
      backgroundColor: "var(--dmg-gray-200)",
      border: "none",
      marginBottom: "20px",
    },
    additionalWrapper: {
      background: "var(--dmg-gray-100)",
      borderBottom: "1px solid var(--dmg-gray-200)",
    },
    delBtn: {},
    processorTitleWrapper: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
    processorTitle: {
      color: "var(--dmg-primary)",
      fontSize: "15px",
      fontWeight: 600,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    Accordion: {
      width: "100%",
      background: "var(--dmg-gray-100)",
    },
    p15: {
      padding: "15px",
    },
    isImg: {
      maxWidth: "200px",
      maxHeight: "100px",
      objectFit: "cover",
      width: "100%",
    },
    isCode: {
      width: "500px",
      height: "300px",
      background: "var(--dmg-text-primary)",
      color: "var(--dmg-bg)",
      overflow: "auto",
      wordBreak: "break-word",
      whiteSpace: "pre-wrap",
      padding: "1rem",
    },
    truncate: {
      width: "350px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    additionalDataBox: {
      borderBottom: "1px solid var(--dmg-gray-200)",
      padding: "10px",
    },
    dashedBox: {
      padding: "1rem",
      border: "1px dashed var(--dmg-gray-500)",
      width: "100%",
    },
    errorDiv: {
      width: "100%",
      height: "100%",
      textAlign: "center",
      margin: "13% 0",
    },
    returnToLastPageButton: {
      backgroundColor: "var(--dmg-primary)",
      color: "var(--dmg-bg)",
      borderRadius: "10px",
      height: "32px",
      width: "200px",
      border: "1px solid var(--dmg-bg)",
    },
    roundedError: {
      fontSize: "4rem",
      fill: "var(--dmg-error)",
    },
    cardTypesSaveButton: {
      backgroundColor: "var(--dmg-blue-accent)",
      color: "var(--dmg-bg)",
      margin: "20px 0",
    },
    cardTypesForm: {
      display: "grid",
      justifyContent: "center",
    },
    cardTypesDiv: {
      margin: "10px 0",
    },
    paddingLeft: {
      paddingLeft: "24px",
    },
    offlineConfigPadding: {
      paddingLeft: "14px",
    },
    header: {
      backgroundColor: "var(--dmg-primary)",
      color: "var(--dmg-bg)",
      padding: "16px",
      borderRadius: "4px 4px 0 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
  };
});

export default useStyles;
